// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-panel{background-color:#bcbdc1;padding:1.5rem}.webinar-title{font-weight:700;font-size:1.2em;margin-bottom:3px}.webinar-subtitle{font-weight:700;margin-bottom:16px}.description{text-align:center;color:#fff;background-color:#414141;padding:20px}.webinar-category{cursor:pointer}.webinar-level{text-transform:uppercase}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
